import React, { useEffect } from "react";
import { Button, Flex, Form, Input, Modal, Select } from "antd";
import { useFetch } from "../../Services/useFetch";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const FilesCreation = [
  {
    id: 1,
    value: "docx",
    fileName: "Word File (.docx)",
  },
  {
    id: 2,
    value: "xlsx",
    fileName: "Excel File (.xlsx)",
  },
  {
    id: 3,
    value: "pptx",
    fileName: "PPT File (.pptx)",
  },
];

const FileCreateUpdate = (props) => {
  const { open, setOpen, loadings, fetchBriefFolderList, handleLoading, parentId, userInfo, socket } = props;

  const [fileForm] = Form.useForm();
  // const { request } = useFetch();
  // const notify = (error) => toast.error(error);
  // const notifySuccess = (msg) => toast.success(msg);
  // const navigate = useNavigate();

  const handleTrimStart = (name, e) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9\s._\-@(){}\[\],&+=]/g, "");
    fileForm.setFieldsValue({ [name]: sanitizedValue.trimStart() });
  };

  const creatBriefFile = async (values, parentId) => {
      // await createBriefFileOnServer(values, parentId);

    const url = `/editor?fileType=${encodeURIComponent(values?.file_type)}&fldId=${encodeURIComponent(
      parentId
    )}&fldName=${encodeURIComponent(values?.file_name)}`;
    window.open(url, "_blank");

    await fetchBriefFolderList(parentId);

    setOpen(false);
  };

  useEffect(() => { 
    socket.on("directory-action", ({ userName, action }) => {});

    return () => {
      socket.off("directory-action");
    };
  }, []);

  return (
    <>
      <Modal
        title="Create File"
        open={open}
        className="bd_model_main shareModal"
        onCancel={() => {
          fileForm.resetFields();
          setOpen(false);
        }}
        footer={null}
      >
        <Form
          name="validateOnly"
          form={fileForm}
          layout="vertical"
          autoComplete="off"
          onFinish={(val) => creatBriefFile(val, parentId)}
        >
          <div className="bd_model_input">
            <Form.Item
              label="File Name"
              name="file_name"
              rules={[{ required: true, message: "File name is required" }]}
            >
              <Input placeholder="Enter here" onChange={(e) => handleTrimStart("file_name", e)} />
            </Form.Item>
          </div>

          <>
            <Form.Item
              label="You want to create a :"
              name="file_type"
              rules={[{ required: true, message: "Please select a file type!" }]}
            >
              <Select
                options={FilesCreation?.map((item) => ({
                  value: item?.value,
                  label: item?.fileName,
                }))}
                // onChange={(value) => {
                //   handleOpenCreateEditor(value);
                // }}
                style={{ height: "32px" }}
              />
            </Form.Item>
          </>

          <Flex justify="flex-end" align="center">
            <Button key="reset" className="BG_ghostButton" onClick={() => fileForm.resetFields()}>
              Reset
            </Button>
            <Button
              key="submit"
              className="BG_mainButton"
              style={{ marginLeft: "20px" }}
              type="primary"
              htmlType="submit"
              loading={loadings?.loadingfile}
              disabled={loadings?.loadingfile}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  );
};

export default FileCreateUpdate;
